import type { RecordsSearch } from '../views/data/records-query.js';

export interface SearchPage<T> {
  results: T[];
  total: number;
}

async function query(route: string, token: string | undefined, body: unknown) {
  const headers: HeadersInit = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch(`%{BUTTRESS_URL}%/%{BUTTRESS_API_PATH}%/api/v1/${route}`, {
    method: 'QUERY',
    headers,
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.message ?? `Search of ${route} failed (${res.status})`);
  return data;
}

// shortcut: crag sends one sort key, and a sorted page needs an _id tie-break, so pages come straight from Buttress until crag takes several keys (after the patch freeze)
export async function searchPage<T>(
  route: string,
  token: string | undefined,
  search: RecordsSearch,
): Promise<SearchPage<T>> {
  const [results, total] = await Promise.all([
    query(route, token, search),
    query(`${route}/count`, token, { query: search.query }),
  ]);
  return { results: results as T[], total: Number(total) };
}
